module.exports = __webpack_public_path__ + "img/avatar2.8eef483b.png";